// extracted by mini-css-extract-plugin
export default {"noWrapText":"oFOqzJqEZSM_shl_oITj"};